import SocialProof from './SocialProof';

export default {
  SocialProof,
};
